import React from "react";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import { Mic, FileText, Users } from "lucide-react";

const MeetingRecording = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Crystal-Clear Meeting Transcriptions in Minutes
        </h1>
        
        <div className="grid md:grid-cols-2 gap-16 mt-12">
          <div>
            <h2 className="text-2xl font-semibold mb-6">Key Features</h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <Mic className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">Flexible Recording</h3>
                  <p className="text-muted-foreground">
                    Record audio with time limits based on your plan, from 30 minutes to unlimited recording time.
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <FileText className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">Advanced Transcription</h3>
                  <p className="text-muted-foreground">
                    Get accurate transcriptions with speaker identification and timestamps (Pro+ tiers).
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <Users className="h-6 w-6 text-primary shrink-0" />
                <div>
                  <h3 className="font-medium mb-2">Real-time Processing</h3>
                  <p className="text-muted-foreground">
                    Premium users enjoy real-time transcription for immediate access to meeting content.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold mb-6">Use Cases</h2>
            <div className="space-y-6">
              <div className="p-6 rounded-lg bg-card">
                <h3 className="font-medium mb-2">Team Discussions</h3>
                <p className="text-muted-foreground">
                  Capture every detail in team discussions or client calls, ensuring no important information is missed.
                </p>
              </div>
              
              <div className="p-6 rounded-lg bg-card">
                <h3 className="font-medium mb-2">Quick Review</h3>
                <p className="text-muted-foreground">
                  Save time by reviewing accurate, searchable transcripts instead of re-watching entire meetings.
                </p>
              </div>
            </div>
            
            <div className="mt-8">
              <Button asChild size="lg">
                <Link to="/pricing">Learn More About Plans</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingRecording;